import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { map, Observable } from 'rxjs';
import { BankAccountsService, EnrichmentRule, EnrichmentRuleAction, EnrichmentRuleActionExpressionCategory, EnrichmentRuleActionExpressionIncome, EnrichmentRuleset, EnrichmentRuleTestResult, INCOME_TYPES, TRANSACTION_TYPES } from 'src/app/shared/services/bank-accounts.service';
import { CATEGORIES, GROUPS, TxnCat, TxnCatGroup } from 'src/app/shared/services/bank-accounts.categories';

@Component({
  selector: 'app-enrichment-rule-add-update',
  templateUrl: './enrichment-rule-add-update.component.html',
  styleUrls: ['./enrichment-rule-add-update.component.scss']
})
export class EnrichmentRuleAddUpdateComponent implements OnInit {
  incTypes = INCOME_TYPES;
  transTypes = TRANSACTION_TYPES;
  testResultsColumnsDisplay: string[] = ["accountName", "date", "description", "amount", "result"];
  ruleset: EnrichmentRuleset = new EnrichmentRuleset();
  testResults: EnrichmentRuleTestResult[] = new Array<EnrichmentRuleTestResult>();
  isEdit: boolean = false;
  runningTest: boolean = false;
  editRuleIndex: number | undefined;

  addEditRuleFrom = this.formBuilder.group({
    ruleType: ['exactMatch', [Validators.required]],
    ruleExpression: ['', [Validators.required]],
    applyCategory: [false, [Validators.required]],
    categoryGroup: [{ value: '', disabled: true }],
    category: [{ value: '', disabled: true }],
    applyTag: [false, [Validators.required]],
    tag: [{ value: '', disabled: true }],
    markAsIncome: [false, [Validators.required]],
    incomeType: [{ value: '', disabled: true }],
    incomeSourceName: [{ value: '', disabled: true }],
    setTransactionType: [false, [Validators.required]],
    transactionType: [{ value: '', disabled: true }]
  });

  categoryData = CATEGORIES;
  categoryGroupData = GROUPS;

  categoryLists: TxnCat[] = new Array<TxnCat>();

  constructor(private bankAccSvc: BankAccountsService, private router: Router, private activatedRoute: ActivatedRoute, private location: Location, breakpointObserver: BreakpointObserver, private formBuilder: FormBuilder) {
    let state = this.router.getCurrentNavigation()?.extras.state;
    console.log(state);
    if (state && state['ruleset']) {
      this.ruleset = state['ruleset'] as EnrichmentRuleset;
    }

    this.activatedRoute.params.subscribe(params => {
      if (params["ruleNumber"]) {
        this.isEdit = true;
        this.editRuleIndex = params["ruleNumber"] as number;
      }
    });
  }

  ngOnInit(): void {
    this.onFormChanges();
    if (this.isEdit) {
      this.populateForm();
    }
  }

  onFormChanges(): void {
    this.addEditRuleFrom.controls.applyCategory.valueChanges.subscribe(val => {
      if (val === true) {
        this.addEditRuleFrom.controls.categoryGroup.enable();
        this.addEditRuleFrom.controls.category.enable();
      } else {
        this.addEditRuleFrom.controls.categoryGroup.disable();
        this.addEditRuleFrom.controls.category.disable();
      }
    });

    this.addEditRuleFrom.controls.applyTag.valueChanges.subscribe(val => {
      if (val === true) {
        this.addEditRuleFrom.controls.tag.enable();
      } else {
        this.addEditRuleFrom.controls.tag.disable();
      }
    });

    this.addEditRuleFrom.controls.markAsIncome.valueChanges.subscribe(val => {
      if (val === true) {
        this.addEditRuleFrom.controls.incomeSourceName.enable();
        this.addEditRuleFrom.controls.incomeType.enable();
      } else {
        this.addEditRuleFrom.controls.incomeSourceName.disable();
        this.addEditRuleFrom.controls.incomeType.disable();
      }
    });

    this.addEditRuleFrom.controls.setTransactionType.valueChanges.subscribe(val => {
      if (val === true) {
        this.addEditRuleFrom.controls.transactionType.enable();
      } else {
        this.addEditRuleFrom.controls.transactionType.disable();
      }
    });
  }

  populateForm() {
    if (this.editRuleIndex) {
      let r = this.ruleset.Rules[this.editRuleIndex];

      this.addEditRuleFrom.patchValue({
        ruleType: r.RuleType,
        ruleExpression: r.RuleExpression
      });

      if (r.Actions) {
        r.Actions.forEach(a => {
          if (a.ActionType === "applyCategory") {
            let c: EnrichmentRuleActionExpressionCategory = JSON.parse(a.ActionExpression as string);
            this.buildCategories(c.GroupId);
            this.addEditRuleFrom.patchValue({
              applyCategory: true,
              categoryGroup: c.GroupId,
              category: c.CategoryId
              //TODO: probably need to change the form to use ID's and values and map to objects for sending and receiving data
            });

          }

          if (a.ActionType === "applyTag") {
            this.addEditRuleFrom.patchValue({
              applyTag: true,
              tag: a.ActionExpression
            });
          }

          if (a.ActionType === "isIncome") {
            let i: EnrichmentRuleActionExpressionIncome = JSON.parse(a.ActionExpression as string);
            this.addEditRuleFrom.patchValue({
              markAsIncome: true,
              incomeSourceName: i.Name,
              incomeType: i.IncomeType
            });

          }

          if (a.ActionType === "setTransactionType") {
            this.addEditRuleFrom.patchValue({
              setTransactionType: true,
              transactionType: a.ActionExpression
            });
          }


        });
      }
    }
  }

  onClickCancel(): void {
    this.location.back();
  }

  onClickAdd(): void {
    if (this.addEditRuleFrom.valid) {
      let rule = this.getRuleFromForm();

      this.ruleset.Rules.push(rule);

      this.router.navigate(['/bank/accounts/enrichment/rulesets', this.ruleset.Id], { state: { ruleset: this.ruleset } });
    }
  }


  onClickRunTest(): void {
    this.testResults = new Array<EnrichmentRuleTestResult>();
    if (this.addEditRuleFrom.valid) {
      this.runningTest = true;
      var rulesToTest: EnrichmentRule[] = new Array<EnrichmentRule>();
      var ruleToTest = this.getRuleFromForm();
      rulesToTest.push(ruleToTest);

      this.bankAccSvc.testRules(rulesToTest)
      .subscribe({
        next: (r) => {
          this.testResults = r;
          this.runningTest = false;
        }
      });
    }
  }

  onClickUpdate(): void {
    if (this.addEditRuleFrom.valid && this.editRuleIndex) {
      let rule = this.getRuleFromForm();

      this.ruleset.Rules[this.editRuleIndex] = rule;

      this.router.navigate(['/bank/accounts/enrichment/rulesets', this.ruleset.Id], { state: { ruleset: this.ruleset } });
    }
  }

  getRuleFromForm() : EnrichmentRule {
    var rule = new EnrichmentRule();

    if(this.editRuleIndex) {
      rule.Id = this.ruleset.Rules[this.editRuleIndex].Id;
      rule.Status = this.ruleset.Rules[this.editRuleIndex].Status;
    }

    var formValues = this.addEditRuleFrom.value;
    rule.RuleType = formValues.ruleType as string;
    rule.RuleExpression = formValues.ruleExpression as string;

    if (formValues.applyCategory === true) {
      let expression = this.buildActionExpressionCategory(formValues.category);
      rule.Actions.push({
        ActionType: "applyCategory",
        ActionExpression: JSON.stringify(expression)
      });
    }

    if (formValues.applyTag === true) {
      rule.Actions.push({
        ActionType: "applyTag",
        ActionExpression: formValues.tag as string
      });
    }

    if (formValues.markAsIncome === true) {
      let expression = new EnrichmentRuleActionExpressionIncome();
      expression.IncomeType = formValues.incomeType as string;
      expression.Name = formValues.incomeSourceName as string;

      rule.Actions.push({
        ActionType: "isIncome",
        ActionExpression: JSON.stringify(expression)
      });
    }

    if (formValues.setTransactionType === true) {
      rule.Actions.push({
        ActionType: "setTransactionType",
        ActionExpression: formValues.transactionType as string
      });
    }

    return rule;
  }

  buildActionExpressionCategory(categoryId: string | null | undefined): EnrichmentRuleActionExpressionCategory | undefined {
    let result = new EnrichmentRuleActionExpressionCategory();
    
    if(!categoryId) {
      return undefined;
    }

    this.categoryData.forEach((x) =>{
      if(x._id === categoryId) {
        result.CategoryId = categoryId;
        result.CategoryText = x.name;
        result.GroupId = x.groups["personal_finance"]._id;
        result.GroupText = x.groups["personal_finance"].name;
      }
    });

    return result;
  }

  buildCategories(groupId: string | null | undefined): void {
    var result = new Array<TxnCat>();

    if (groupId) {
      this.categoryData.forEach((x) => {
        if (x.groups["personal_finance"]._id === groupId) {
          result.push(x);
        }
      });
    }

    this.categoryLists = result;
  }
}
